let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("i2OFv"), load("ffEVr"), load("klGUa")]).then(() => parcelRequire('8o2bj'));